<template>
  <!-- 关键词 文章列表 -->
  <div class="container">
    <!-- 内容 -->
    <div class="center">
      <div class="content">
        <!-- 快讯详细信息 -->
        <div class="left">
          <div class="now-flash">
            <V-One
              v-if="item"
              :title="item.title"
              :reference="item.link||''"
              :accessory="item.fileLink||''"
              :time="item.time"
              :content="item.context||''"
              :id="item.id"
            ></V-One>
          </div>
        </div>
        <!-- 24小时热榜 -->
        <div class="right">
          <div>
            <V-Right :list="hotlist" @updateCon="updateCon"></V-Right>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleNav from "@/components/article-nav/index.vue";
import One from "@/views/academic-headlines/common/news-flash-detail/one/index.vue";
import Right from "@/views/academic-headlines/common/news-flash-detail/right/index.vue";

export default {
  data() {
    return {
      item:null,  
      hotlist:[],
    };
  },
  created: function() {
    let params = this.$route.params;
    if(params&&JSON.stringify(params)!=='{}'){
      sessionStorage.setItem('kx',JSON.stringify(params));
      this.item = params.item
      this.hotlist = params.hotlist
    }else{
      try {
        let str = sessionStorage.getItem('kx');
        params = JSON.parse(str);
        this.item = params.item
        this.hotlist = params.hotlist
      } catch (error) {
        
      }
    }
  },
  beforeDestroy(){
    sessionStorage.removeItem('kx');
  },

  methods: {
    updateCon(item){
      this.item = item;
    },

  },
  components: {
    "V-ArticleNav": ArticleNav,
    "V-One": One,
    "V-Right": Right
  }
};
</script>

<style scoped>
.container {
  text-align: center;
  background-color: #f7f7f7;
}
.container > .head {
  height: 100px;
  line-height: 100px;
  background-color: #e8eaeb;
}
.container > .center {
  margin-top: 30px;
  width: 100%;
  padding-bottom: 30px;
}
.container > .center > .content > .left {
  padding: 30px;
  /* height: 1130px; */
  overflow: hidden;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
.container > .head > div,
.container > .center > .content {
  width: 1090px;
  display: inline-block;
  text-align: left;
  position: relative;
}
.container > .center > .content > .left {
  display: inline-block;
  width: 620px;
  background-color: #ffffff;
}
.container > .center > .content > .right {
  display: inline-block;
  padding: 10px 5px 15px 10px;
  vertical-align: top;
  width: 25%;
  margin-left: 30px;
  /* text-align: center; */
  background-color: #ffffff;
  /* height: 1190px; */
}
.container > .center > .content > .right > div {
  display: inline-block;
  width: 100%;
}
.container > .center > .content > .left > .now-flash {
  padding: 20px 0;
}
.next-newsflash-item {
  padding: 20px;
  border-top: 2px solid black;
  margin-top: 50px;
  border-left: 1px solid rgb(223, 217, 217);
  border-right: 1px solid rgb(223, 217, 217);
  border-bottom: 1px solid rgb(223, 217, 217);
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.next-newsflash-item > div:first-of-type > span {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 36px;
}
.next-newsflash-item > div:first-of-type > span > span {
  display: inline-block;
  border-bottom: 2px solid rgb(155, 151, 151);
  padding-bottom: 10px;
}
.next-newsflash-item .modify-pad {
  box-sizing: border-box;
  /* padding-bottom: 20px; */
  height: 40px;
  overflow: hidden;
}
</style>
